// extracted by mini-css-extract-plugin
export default {"container":"paymentStatus_container__cf3vW","message":"paymentStatus_message__hMOfo"};